import React, { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const TotalPointsTag = ({ email }) => {
  const [points, setPoints] = useState(null);

  const fetchPoints = async () => {
    const url = `${BACKEND_URL}/user/${encodeURIComponent(email)}/points`;
    try {
      const res = await fetch(url);
      const data = await res.json();
      if (res.ok && typeof data.totalPoints === "number") {
        setPoints(data.totalPoints);
      }
    } catch (error) {
      console.error("❌ Error fetching total points:", error);
    }
  };

  useEffect(() => {
    if (!email) return;
    fetchPoints();
    const interval = setInterval(fetchPoints, 30000);
    return () => clearInterval(interval);
  }, [email]);

  if (points === null) return null;

  return (
    <div
      className="group relative flex items-center gap-2 px-4 py-1.5 rounded-full border border-neutral-700 bg-neutral-900 text-white font-semibold text-sm shadow-sm hover:shadow-md hover:scale-[1.02] transition-all duration-200 ease-in-out"
      title="Your Frontera points"
    >
      <Sparkles className="w-4 h-4 text-white opacity-70 group-hover:animate-spin-slow" />
      {points.toLocaleString()} pts

      {/* Hover Tooltip */}
      <div className="absolute -bottom-10 left-1/2 transform -translate-x-1/2 scale-0 group-hover:scale-100 bg-black text-white text-xs px-3 py-1 rounded-full shadow-md transition-all duration-200 ease-in-out whitespace-nowrap z-50">
        Earned by Solving. Tracked forever.
      </div>
    </div>
  );
};

export default TotalPointsTag;
